<script>
    import Hammer from 'hammerjs';
    import {EventBus, lazyLoadInstance} from "../../../common/common";
    import {CLOSE_DESKTOP_MENU_EVENT, SHOW_MOBILE_MENU_EVENT} from "../../../common/header";
    import cr$ from "../../../common/crquery";

    export default {
        el: '#header-menu',

        name: "HeaderMenu",

        data() {
            const themesGroupBaseObj = hideShowAll => {
                const obj = {
                    title: 'Temas',
                    items: [
                        {label: 'Cinema', url: 'cinema/'},
                        {label: 'Séries', url: 'series/'},
                        {label: 'Geek', url: 'geek/'},
                        {label: 'Games', url: 'games/'},
                        {label: 'Brasilidade', url: 'brasilidade/'},
                        {label: 'Literatura', url: 'literatura/'},
                        {label: 'Música', url: 'musica/'},
                        {label: 'Humor', url: 'humor/'},
                    ]
                };

                if (!hideShowAll)
                    obj.items.push({label: 'Ver todos', url: '', extraClasses: ['margin-top', 'text-bold']});

                return obj;
            };

            return {
                openedSection: null,
                cancelOpenSection: false,

                slideMobileDrawerToRight: false,
                hideMobileDrawer: true,

                showMobilePartnersSection: false,
                showMobileAboutSection: false,
                showMobileMiscSection: false,

                sections: {
                    shirts: {
                        id: 'header-detail-shirts',

                        groups: [
                            {
                                title: 'Masculino',
                                titleUrl: '/camiseta/masculino/',
                                baseUrl: '',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Camisetas', url: '/camiseta/masculino/'},
                                    {label: 'Linha Básica', url: '/roupas/linha-basica/masculino/'},
                                    {label: 'Camisetas com bolso', url: '/camiseta/camisetas-com-bolso/masculino/'},
                                    {label: 'Camisas Polo', url: '/polo/'},
                                    {label: 'Linha Inverno', url: '/moletom/'}
                                ]
                            },

                            {
                                title: 'Feminino',
                                titleUrl: '/camiseta/feminino/',
                                baseUrl: '',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Camisetas', url: '/camiseta/feminino/'},
                                    {label: 'Linha básica', url: '/roupas/linha-basica/feminino/'},
                                    {label: 'Regatas', url: '/regata/feminino/'},
                                    {label: 'Camisetas com bolso', url: '/camiseta/camisetas-com-bolso/feminino/'},
                                    {label: 'Linha Inverno', url: '/moletom/'},
                                ]
                            },

                            {
                                baseUrl: '/camiseta/',
                                extraClasses: ['nowrap', 'visible-lg'],
                                ...themesGroupBaseObj(true)
                            }
                        ],

                        thumbs: [
                            {image: 'camiseta-1.jpg', link: '/camiseta/filmes-brasileiros/'},
                            {image: 'camiseta-2.jpg', link: '/camiseta/series-dignas-de-maratona/'}
                        ]
                    },

                    mugs: {
                        id: 'header-detail-mugs',

                        groups: [{
                            baseUrl: '/caneca/',
                            ...themesGroupBaseObj()
                        }],

                        thumbs: [
                            {image: 'canecas-1.jpg', link: '/caneca/filmes-premiados/'},
                            {image: 'canecas-2.jpg', link: '/caneca/series-de-anime/'},
                            {image: 'canecas-3.jpg', link: '/caneca/cafe/'},
                        ]
                    },

                    posters: {
                        id: 'header-detail-posters',

                        groups: [{
                            baseUrl: '/poster/',
                            ...themesGroupBaseObj()
                        }],

                        thumbs: [
                            {image: 'poster-1.jpg', link: '/poster/musica-brasileira/'},
                            {image: 'poster-2.jpg', link: '/poster/serie-dos-anos-90/'},
                            {image: 'poster-3.jpg', link: '/poster/filmes-classicos/'},
                        ]
                    },

                    cases: {
                        id: 'header-detail-cases',

                        groups: [{
                            baseUrl: '/capinhas-para-celular/',
                            ...themesGroupBaseObj()
                        }],

                        thumbs: [
                            {image: 'capa-1.jpg', link: '/capinhas-para-celular/filmes-para-vida/'},
                            {image: 'capa-2.jpg', link: '/capinhas-para-celular/musica-internacional/'},
                            {image: 'capa-3.jpg', link: '/capinhas-para-celular/lgbt/'},
                        ]
                    },

                    pillows: {
                        id: 'header-detail-pillows',

                        groups: [{
                            baseUrl: '/almofada/',
                            ...themesGroupBaseObj()
                        }],

                        thumbs: [
                            {image: 'almofada-1.jpg', link: '/almofada/literatura-internacional/'},
                            {image: 'almofada-2.jpg', link: '/almofada/mashup/'},
                            {image: 'almofada-3.jpg', link: '/almofada/positividade/'},
                        ]
                    },

                    sketchbooks: {
                        id: 'header-detail-sketchbooks',

                        groups: [{
                            baseUrl: '/sketchbook/',
                            ...themesGroupBaseObj()
                        }],

                        thumbs: [
                            {image: 'sketch-1.jpg', link: '/sketchbook/filmes-de-romance/'},
                            {image: 'sketch-2.jpg', link: '/sketchbook/tipografia/'},
                            {image: 'sketch-3.jpg', link: '/sketchbook/literatura-nacional/'},
                        ]
                    },

                    more: {
                        id: 'header-detail-more',

                        groups: [
                            {
                                title: 'Acessórios',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Óculos escuros', url: '/oculos/'},
                                    {label: 'Bolsas e mochilas', url: '/loja/bolsas-e-mochilas/'},
                                    {label: 'Meias', url: '/meia/'},
                                    {label: 'Aventais', url: '/aventais-personalizados/'},
                                    {
                                        label: 'Vale-presente',
                                        url: '/vale-presente',
                                        extraClasses: ['margin-top', 'text-bold']
                                    },
                                ]
                            },
                            {
                                title: 'Parcerias',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Frida Kahlo', url: '/frida-kahlo'},
                                    {label: 'Meu Adorável Iglu', url: '/meu-adoravel-iglu'},
                                    {label: 'Milton Nascimento', url: '/milton-nascimento'},
                                    {label: 'Catuaba Selvagem', url: '/catuaba-selvagem'},
                                ]
                            },
                            {
                                title: 'Artistas Convidados',
                                baseUrl: '/artistas',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Rodrigobhz', url: '/rodrigobhz'},
                                    {label: 'Vó Maria', url: '/vo-maria'},
                                    {label: 'Rhodrigo Maia', url: '/rhodrigo-maia'},
                                    {label: 'Mathiole', url: '/mathiole'},
                                    {label: 'Ilustrata', url: '/ilustrata'},
                                    {label: 'Ver todos', url: '', extraClasses: ['margin-top', 'text-bold']},
                                ]
                            },
                            {
                                title: 'A Chico Rei',
                                extraClasses: ['nowrap'],
                                items: [
                                    {label: 'Quem Somos', url: '/minas-para-o-mundo'},
                                    {label: 'Camisetas Mudam o Mundo', url: '/camisetas-mudam-o-mundo'},
                                    {label: 'Equipe', url: '/eu-faco'},
                                    {label: 'Por que Chico Rei?', url: '/a-fantastica-historia-de-chico-rei'},
                                ]
                            },
                        ],
                    },

                    collab: {
                        id: 'header-detail-collab',
                        groups: [],
                    },

                    about: {
                        id: 'header-detail-about',
                        groups: [],
                    }
                },
            }
        },

        created() {
            EventBus.$on(SHOW_MOBILE_MENU_EVENT, () => this.slideMobileDrawerToRight = true);
            EventBus.$on(CLOSE_DESKTOP_MENU_EVENT, () => this.closeSection());
        },

        mounted() {
            if (this.$refs.headerProductsWrapper) {
                const panHandler = (e) => {
                    if (e.isFinal && e.additionalEvent === 'panleft') {
                        this.slideMobileDrawerToRight = false;
                    }
                };

                const panRecognizer = new Hammer.Pan({
                    threshold: 0,
                    pointers: 0,
                    direction: Hammer.DIRECTION_HORIZONTAL
                });

                this.sliderManager = new Hammer.Manager(this.$refs.headerProductsWrapper);
                this.sliderManager.add(panRecognizer);
                this.sliderManager.on('pan', panHandler);
            }

            this.$nextTick(() => lazyLoadInstance.update());
        },

        watch: {
            slideMobileDrawerToRight(newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.hideMobileDrawer = false;
                } else if (!newValue && oldValue) {
                    setTimeout(() => this.hideMobileDrawer = true, 500);
                }
            }
        },

        methods: {
            openSection(section) {
                this.cancelOpenSection = false;
                setTimeout(() => {
                    if (!this.cancelOpenSection) {
                        this.openedSection = section;
                    } else {
                        this.cancelOpenSection = false;
                    }
                }, 100);
            },

            closeSection() {
                this.cancelOpenSection = true;
                this.openedSection = null;
                cr$.byId('header').removeClass('do-slide');
            }
        }
    }
</script>